import { EarnNavigator, EarnStackRoutes } from './earn.navigator';
export { EarnNavigator, EarnStackRoutes, EarnTabRoutes, EarnStackParamList } from './earn.navigator';
import en from './i18n/en.json';
import zhHk from './i18n/zh-HK.json';
import zhCn from './i18n/zh-CN.json';
import jaJp from './i18n/ja-JP.json';
import React from 'react';
import { PathConfigMap } from '@react-navigation/native';
import { RootStackRoutes } from 'types';

export type FeatureModule = {
  name: string;
  version: string;
  hooks: Record<string, Function>;
  screens: Record<string, React.FC>;
  routes: PathConfigMap<any>;
  i18n: {
    en: Record<string, any>;
    'zh-HK': Record<string, any>;
    'zh-CN': Record<string, any>;
    'ja-JP': Record<string, any>;
  };
};

const EarnApp: FeatureModule = {
  name: RootStackRoutes.Earn,
  version: '1.0.0',
  hooks: {},
  screens: {
    main: EarnNavigator,
    EarnNavigator
  },
  routes: {
    [EarnStackRoutes.Root]: {
      path: 'earn',
      exact: true
    }
  },
  i18n: {
    en: en as Record<string, any>,
    'zh-HK': zhHk as Record<string, any>,
    'zh-CN': zhCn as Record<string, any>,
    'ja-JP': jaJp as Record<string, any>
  }
};

export default EarnApp;
